import * as React from "react";
import type { SVGProps } from "react";
const SvgBag04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.6 8.4v-3a3.6 3.6 0 0 0-7.2 0v3M4.727 22.2h14.546c1.285 0 2.327-1.023 2.327-2.284L20.11 7.8c0-1.261-1.043-2.284-2.328-2.284H5.927C4.642 5.516 3.6 6.539 3.6 7.8L2.4 19.916c0 1.261 1.042 2.284 2.327 2.284"
    />
  </svg>
);
export default SvgBag04;
